var _ellipse, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 35,
    viewBox: "0 0 34 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.8255,
    cy: 17.0759,
    rx: 16.8254,
    ry: 17.0759,
    transform: "rotate(-180 16.8255 17.0759)",
    fill: "#FF510D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8442 17.654L15.7547 23.7749C15.4408 24.0575 14.9699 24.0575 14.6874 23.7749L13.9655 23.053C13.683 22.7705 13.683 22.2996 13.9655 21.9857L18.7995 17.1518L13.9655 12.2864C13.683 11.9725 13.683 11.5017 13.9655 11.2192L14.6874 10.4972C14.9699 10.2147 15.4408 10.2147 15.7547 10.4972L21.8442 16.6182C22.1267 16.9007 22.1267 17.3715 21.8442 17.654Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightOutlined);
export default __webpack_public_path__ + "static/media/rightOutlined.1ab0e7c410434d4d548dcc70a5ead0c0.svg";
export { ForwardRef as ReactComponent };